import { render, staticRenderFns } from "./TrendBarChart.vue?vue&type=template&id=4678c597&"
import script from "./TrendBarChart.vue?vue&type=script&lang=ts&"
export * from "./TrendBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports